import React, { Component } from 'react'
import ReactSelect from 'react-select'

// Menu is rendered in a portal on document.body (menuPosition="fixed") so it
// escapes the modal's `overflow-y: auto` container and never gets clipped or
// forces the modal itself to scroll. z-index kept above the modal (see
// $gl2026-modal-dialog-z in _modal.scss).
const selectMenuPortalStyles = {
  menuPortal: function(base) { return { ...base, zIndex: 9999 } },
}

export default class InvoiceProductForm extends Component {
  render() {
    const {
      brands, groups, categories, products, saleTypes,
      onCancel, initialQuantity, initialUnitPrice,
      selectedSaleType, selectedProduct,
      selectedBrand, selectedGroup, selectedCategory,
    } = this.props

    return (
      <form onSubmit={this.props.onSubmit} className="invoice-product-form">
        <div className="invoice-product-form-grid">
          <Field label="Tipo de instalação">
            <ReactSelect
              isClearable
              onChange={this.props.onSaleTypeChange}
              options={saleTypes}
              value={selectedSaleType}
              getOptionLabel={function(o) { return o.name }}
              getOptionValue={function(o) { return o.id }}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={selectMenuPortalStyles}
            />
          </Field>
          <Field label="Marca">
            <ReactSelect
              isClearable
              onChange={this.props.onBrandChange}
              options={brands}
              value={selectedBrand}
              getOptionLabel={function(o) { return o.name }}
              getOptionValue={function(o) { return o.id }}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={selectMenuPortalStyles}
            />
          </Field>
          <Field label="Grupo">
            <ReactSelect
              isClearable
              isDisabled={groups.length === 0}
              onChange={this.props.onGroupChange}
              options={groups}
              value={selectedGroup}
              getOptionLabel={function(o) { return o.name }}
              getOptionValue={function(o) { return o.id }}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={selectMenuPortalStyles}
            />
          </Field>
          <Field label="Categoria">
            <ReactSelect
              isClearable
              isDisabled={categories.length === 0}
              onChange={this.props.onCategoryChange}
              options={categories}
              value={selectedCategory}
              getOptionLabel={function(o) { return o.name }}
              getOptionValue={function(o) { return o.id }}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={selectMenuPortalStyles}
            />
          </Field>
          <Field label="Código do produto">
            <ReactSelect
              isClearable
              isDisabled={products.length === 0}
              onChange={this.props.onProductChange}
              options={products}
              value={selectedProduct}
              getOptionLabel={function(o) { return o.external_identifier }}
              getOptionValue={function(o) { return o.id }}
              placeholder="Selecione"
              className="w-full"
              classNamePrefix="invoice-select"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={selectMenuPortalStyles}
            />
          </Field>
          <Field label="Preço">
            <input
              type="number"
              name="unit_price"
              min="0"
              step="0.01"
              inputMode="decimal"
              defaultValue={initialUnitPrice != null ? initialUnitPrice : ''}
              placeholder="Inserir preço"
              className="invoice-form-input"
            />
          </Field>
          <Field label="Quantidade">
            <input
              type="number"
              name="quantity"
              min="1"
              defaultValue={initialQuantity || 1}
              placeholder="Inserir quantidade"
              className="invoice-form-input"
            />
          </Field>
        </div>

        <div className="invoice-product-form-footer">
          <button type="button" className="gl-button secondary medium body-m" onClick={onCancel}>
            Cancelar
          </button>
          <button type="submit" className="gl-button primary medium body-m">
            {initialQuantity ? 'Guardar' : 'Adicionar'}
          </button>
        </div>
      </form>
    )
  }
}

const Field = function({ label, children }) {
  return (
    <div className="invoice-product-form-field">
      <label className="invoice-form-label">{label}</label>
      {children}
    </div>
  )
}
